import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Swiper, { Navigation, Pagination } from 'swiper';
import { formatImage } from '@ifeng-fe/public_method';
import { getThumbnail } from '@src/common/utils';

Swiper.use([ Navigation, Pagination ]);

class MainSwiper extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    state = {
        swiper: null,
        swiperIndex: 0
    }

    componentDidMount() {
        const { content } = this.props;
        const { swiperIndex } = this.state;
        // eslint-disable-next-line consistent-this
        const that = this;
        const swiper = new Swiper('#swiper2', {
            loop: true,
            slidesPerView: 3,
            slidesOffsetBefore: (window.innerWidth - 1000) / 2,
            navigation: {
                prevEl: '.prev2_1, .prev2_2',
                nextEl: '.next2_1, .next2_2'
            },
            pagination: {
                el: '.pagination2'
            },
            on: {
                click () {
                    window.open(content[swiperIndex].url);
                },
                slideChangeTransitionEnd () {
                    that.setState({
                        swiperIndex: this.realIndex
                    });
                }
            }
        });

        this.setState({ swiper });
        window.addEventListener('resize', this.updateSwiper);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSwiper);
    }

    updateSwiper = () => {
        const { swiper } = this.state;

        swiper.params.slidesOffsetBefore = (window.innerWidth - 1000) / 2;
        swiper.update();
    };

    render() {
        const { content } = this.props;
        const { swiperIndex } = this.state;

        return (
            <div className={styles.container} style={{ width: '3000px' }}>
                <div className="swiper" id="swiper2" style={{ width: '3000px' }}>
                    <div className="swiper-wrapper">
                        {
                            content.map((data, index) => {
                                return (
                                    <div key={index} className="swiper-slide" style={{ width: '1000px' }}>
                                        <div className={styles.swiperItem}>
                                            <img src={formatImage(getThumbnail(data), 1000 * 2, 562 * 2)} alt={data.title} />
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <div className={styles.mask}>
                    <div className={`${styles.left} prev2_1`}>
                        <div className={`${styles.leftBtn} prev2_2`} />
                    </div>
                    <div className={styles.center}>
                            <div className={styles.textPart}>
                                <div className={styles.title}>{content[swiperIndex].title}</div>
                                <div className={styles.subTitle}>
                                    {content[swiperIndex].summary}
                                </div>
                            </div>
                        <div className={`${styles.pagination} pagination2`} />
                    </div>
                    <div className={`${styles.right} next2_1`}>
                        <div className={`${styles.rightBtn} next2_2`} />
                    </div>
                </div>
            </div>
        );
    }
}

export default MainSwiper;
